import { useEffect } from "react";

type SEOProps = {
  title: string;
  description: string;
  image?: string;
  canonicalPath?: string;
  jsonLd?: Record<string, unknown>;
  noIndex?: boolean;
};

function setMeta(name: string, content: string, property = false) {
  const attr = property ? "property" : "name";
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }

  tag.content = content;
}

export function SEO({ title, description, image, canonicalPath, jsonLd, noIndex = false }: SEOProps) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("robots", noIndex ? "noindex,nofollow" : "index,follow");
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", "website", true);

    if (image) {
      setMeta("og:image", image, true);
    }

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://thedepositseedhouse.com${canonicalPath ?? window.location.pathname}`;

    const existing = document.getElementById("structured-data");
    existing?.remove();

    if (jsonLd) {
      const script = document.createElement("script");
      script.id = "structured-data";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [canonicalPath, description, image, jsonLd, noIndex, title]);

  return null;
}
